import styled from "styled-components";
import Image from "../Image";
import { colors, fonts, media, getOuterSpace } from "../../style/constants";

export const ListTitle = styled.h2`
  color: #fff;
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 1rem;

  &::after {
    content: "";
    width: 1rem;
    height: 1px;
    background: ${colors.red500};
    display: inline-block;
    vertical-align: middle;
    margin-left: 1rem;
  }
`;
export const SubTitle = styled.h3`
  color: #fff;
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 1rem;
  text-decoration: underline;
`;
export const NewList = styled.div`
  .tbg {
    grid-column: 2 / span 3;
    grid-row-start: 3;
    img {
      width: 100%;
    }
    ${media.md`
    grid-row-start: 1;
    grid-column: 1 / span 4;
  `}
  }
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(5, 1fr);
  position: relative;
  height: 60vh;
  grid-gap: 1rem;
  padding: 1rem;
  ${media.md`
    padding: 3rem;
    height: auto;
    grid-template-rows: auto;
  `}
  ${media.sm`
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    padding: 1.5rem;
    height: auto;
  `}
  article {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    grid-column: 2 / span 2;
    grid-row: 3 / 4;
    h1 {
      font-size: 1.3rem;
      margin-bottom: 1rem;
    }
    p {
      margin-bottom: 1rem;
    }
    a {
      text-decoration: underline;
      color: white;
    }
    &:first-of-type {
      grid-column: 5 / span 2;
    }
    ${media.md`
      grid-template-rows: auto;
      grid-row: 1 / 2;
      grid-column: 1 / span 3;
      &:first-of-type {
       grid-column: 5 / span 3;
      }
    `}
    ${media.sm`
    &:first-of-type {
       grid-column: 1 / span 4;
       grid-row: 2 / 2;
      }
  `}
  }
`;

export const StyledImage = styled(Image)`
  grid-area: 1 / 3 / 5 / 9;
  position: relative;
  overflow: hidden;
  margin: -1rem;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: auto;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    display: block;
    object-fit: contain;
    object-position: center;
    z-index: 2;
    ${media.sm`

    `}
  }

  ${media.md`
  margin: -3rem;
  `}
  ${media.sm`
  margin: -1.5rem;
    grid-area: 1 / 5 / 4 / 1;
    &:before {
      padding-top: 100%;
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/ProfileList/style.js